export default __webpack_public_path__ + "static/media/blunderbuss.aa96504f.png";